import {getHours, getMinutes, set} from 'date-fns';
import {
  Button,
  ButtonGroup,
  closeCurrentDialog,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
  TimeType,
} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';
import {z} from 'zod';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

type PlanExecutionFormModel = {
  date: Date;
  time: TimeType;
};

export interface UpdateJobDetailProps {
  onSubmit: (plannedDate: Date) => void;
}

export function PlanExecutionForm(props: UpdateJobDetailProps) {
  const handleOnSubmit: FormSubmitHandler<PlanExecutionFormModel> = async (values) => {
    // Converting time value from TimeType (05:00) to Date object (Thu Jan 01 1970 05:00:00 GMT+0100 (Central European Standard Time))
    const timeObject = parseDate(`1970-01-01T${values.time}`);

    const plannedDate = set(values.date, {
      hours: getHours(timeObject),
      minutes: getMinutes(timeObject),
    });

    await props.onSubmit(plannedDate);
  };

  return (
    <Form<PlanExecutionFormModel>
      onSubmit={handleOnSubmit}
      // @ts-ignore
      experimentalZodSchema={PlanExecutionFormSchema}
    >
      {(control) => (
        <VStack spacing={4}>
          <HStack spacing={4}>
            <FormField
              isRequired
              name="date"
              type="date"
              control={control}
              label={i18n.t('general.labels.date')}
            />
            <FormField
              isRequired
              name="time"
              type="time"
              control={control}
              label={i18n.t('general.labels.time')}
            />
          </HStack>

          <ButtonGroup align="right">
            <Button
              variant="secondary"
              onClick={closeCurrentDialog}
              title={i18n.t('general.actions.discard')}
            />
            <FormButton control={control} type="submit" title={i18n.t('general.actions.confirm')} />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}

const PlanExecutionFormSchema = z.object({
  date: z.date(),
  time: z.string(),
});
